module.exports = __webpack_public_path__ + "static/media/Logo-HOME.6c78ba99.png";